import { Injectable } from '@angular/core';
import { UUID } from 'angular2-uuid';


@Injectable( {
    providedIn: 'root'
} )
export class UidService {

    constructor() { }

    public generate (): string {
        return UUID.UUID();
    }

}
